import { createContext } from 'react';
import { WidgetDetails } from 'redux/services/widgets/interface';

export interface WidgetContextType {
  widget: WidgetDetails;
  setWidget: React.Dispatch<React.SetStateAction<WidgetDetails>>;
}

export const WidgetContext = createContext<WidgetContextType | undefined>(undefined);
